<template>
  <router-view></router-view>
</template>

<script>
import config from "./view/config.vue";

export default {
  name: "App",
  components: {
    config,
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
